import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, Span, ProgressBox, ProgressStat } from '../styles';
import { polarColors } from '../constants';

const getColor = value => {
  if (value < 25) {
    return polarColors[4];
  }
  if (value < 50) {
    return polarColors[3];
  }
  if (value < 75) {
    return polarColors[1];
  }
  return polarColors[0];
};

const CreenciasHabilidades = ({ user, background, number }) => {
  const ability = (parseFloat(user['HABILIDADES']) / 6) * 100;
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h1>3. Teorías personales sobre el desarrollo de habilidades</h1>
          <h2>3.1. Creencias generales</h2>
          <p className='justified'>
            Las teorías personales sobre el desarrollo de habilidades son las{' '}
            <strong>
              creencias que tenemos sobre si es posible (o no) mejorar alguna
              habilidad
            </strong>
            . Algunas personas pueden creer que sus habilidades son fijas, "de
            nacimiento", o que no se pueden cambiar. Otras personas ven sus
            habilidades como algo que se puede mejorar con práctica y esfuerzo.
            Las creencias sobre si podemos o no mejorar nuestras habilidades
            tiene un gran impacto en nuestros resultados escolares y en la
            disposición a enfrentar nuevos desafíos. Por ejemplo, si una persona
            cree que las habilidades de lectura no se pueden cambiar, no estará
            dispuesta a practicar más para mejorar su comprensión lectora. Pero
            si cree que las habilidades se pueden mejorar, entonces estará más
            motivada a buscar la forma de mejorar su capacidad lectora.
          </p>
          <p className='justified'>
            El siguiente gráfico muestra cómo son tus creencias, de acuerdo a
            tus respuestas al test. Resultados en
            <Span strong color={polarColors[0]}>
              {' '}
              ROJO{' '}
            </Span>
            sugieren una tendencia a pensar en las habilidades como algo fijo,
            que no se puede mejorar, mientras que los resultados en{' '}
            <Span strong color={polarColors[4]}>
              VERDE
            </Span>{' '}
            sugieren que tus creencias son más compatibles con la idea de que
            las habilidades sí pueden desarrollarse.
          </p>
          <p className='justified'>
            Si obtienes bajos puntajes en esta área,{' '}
            <strong>
              es importante que reflexiones sobre cómo llegaste a la conclusión
              de que las habilidades no se pueden mejorar y en qué medida estas
              creencias te han afectado o te han limitado en el pasado
            </strong>
            . Ten presente que incluso aquellas personas que exhiben habilidades
            impresionantes en determinadas áreas, tuvieron que invertir
            muchísimo tiempo y esfuerzo para alcanzar ese nivel. Es decir,
            independientemente de nuestras diferencias y limitaciones,{' '}
            <strong>
              creer que podemos mejorar es fundamental para avanzar hacia
              nuestros objetivos de desarrollo
            </strong>
            .
          </p>
          <div className='progress-info-group' style={{ marginTop: 48 }}>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <ProgressBox
                  progress={ability}
                  backColor={() => getColor(100 - ability)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{ability.toFixed(0)}</ProgressStat>
              </div>
            </div>
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default CreenciasHabilidades;
